module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTEwIDIwYTEwIDEwIDAgMSAxIDAtMjAgMTAgMTAgMCAwIDEgMCAyMHptMi0xM2MwIC4yOC0uMjEuOC0uNDIgMUwxMCA5LjU4Yy0uNTcuNTgtMSAxLjYtMSAyLjQydjFoMnYtMWMwLS4yOS4yMS0uOC40Mi0xTDEzIDkuNDJjLjU3LS41OCAxLTEuNiAxLTIuNDJhNCA0IDAgMSAwLTggMGgyYTIgMiAwIDEgMSA0IDB6bS0zIDh2Mmgydi0ySDl6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/images/question.svg
// module id = 456
// module chunks = 35783957827783